import App from "./App";
import LandingPage from "./pages/LandingPage.jsx";
import { createRoot } from "react-dom/client";
import { initI18n } from "./utils/i18nUtils";
import './assets/admin.css';
import '../../extensions/count-down/assets/mv-timer-bar.css';

// Ensure that locales are loaded before rendering the app
initI18n().then(() => {
  const root = createRoot(document.getElementById("app"));
  const isEmbedded = window.self !== window.top;
  root.render(isEmbedded ? <App /> : <LandingPage />);
});
